const SpaceTypes = {
  SPACE: 'space',
  STUDIO: 'studio',
};

export default SpaceTypes;
